module.exports = __webpack_public_path__ + "img/sy-pic1.edee4bb4.png";